import React, { Component } from 'react'
import styled from 'styled-components'
import Carousel from 'nuka-carousel'
import { rem } from 'polished'

import arrayConcatDedupe from 'lib/array/arrayConcatDedupe'

const transitionDuration = 300 // milliseconds

const CarouselWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 0 ${rem(15)};
`

const Highlight = styled.div`
  position: absolute;
  left: ${rem(15)};
  bottom: 0;
  width: ${rem(280)};
  height: ${rem(4)};
  background-color: ${({ theme }) => theme.palette.brand.primary.normal};
`

interface Props {
  offers: Array<App.Offer | App.OfferSummary>;
  onSlideChange: (id: string) => void;
  carouselSettings: Partial<React.ComponentProps<typeof Carousel>>;
  hasHighlight?: boolean;
}

class OfferCarousel extends Component<React.PropsWithChildren<Props>> {
  currentSlide: number
  carousel: any

  constructor(props: Props) {
    super(props)
    this.currentSlide = 0
  }

  shouldComponentUpdate(nextProps: Props) {
    // Check for different props
    const propsKeys = arrayConcatDedupe(Object.keys(this.props), Object.keys(nextProps))
    for (const key of propsKeys) {
      if (this.props[key] !== nextProps[key]) {
        return true
      }
    }

    return false
  }

  goToSlideForOffer(offerId: string) {
    const index = this.props.offers.findIndex(
      offer => offer.id === offerId,
    )
    if (this.carousel && index > -1 && index !== this.currentSlide) {
      this.carousel.goToSlide(index)
      this.currentSlide = index
    }
  }

  afterSlide = (newIndex: number) => {
    const { onSlideChange, offers } = this.props
    this.currentSlide = newIndex

    const selectedOffer = offers[newIndex]
    if (selectedOffer) {
      onSlideChange && onSlideChange(selectedOffer.id)
    }
  }

  render() {
    const { children, hasHighlight, carouselSettings } = this.props

    return <CarouselWrapper>
      <Carousel
        {...carouselSettings}
        ref={el => this.carousel = el}
        afterSlide={this.afterSlide}
        slidesToScroll={1}
        wrapAround
        swiping
        speed={transitionDuration}
      >
        { children }
      </Carousel>
      {hasHighlight && <Highlight/>}
    </CarouselWrapper>
  }
}

export default OfferCarousel
